import React from "react";
import styles from "./Contact.module.css"; // Import CSS Module

const Contact = () => {
  return (
    <div className={styles.contactPage}>
      <div className={styles.contactContainer}>
        <div className={styles.contactHeader}>
          <h1 className={styles.pageTitle}>Contact Us</h1>
          <p className={styles.pageSubtitle}>
            Have questions or feedback? We'd love to hear from you!
          </p>
        </div>

        <div className={styles.contactContent}>
          <div className={styles.contactFormContainer}>
            <div className={styles.contactFormCard}>
              <form
                className={styles.contactForm}
                action="mailto:imagecompressor123@gmail.com"
                method="post"
                encType="text/plain"
              >
                <div className={styles.formGroup}>
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Your name"
                    className={styles.formInput}
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Your email"
                    className={styles.formInput}
                    required
                  />
                </div>

                <div className={styles.formGroup}>
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="Message"
                    rows="5"
                    placeholder="Your message"
                    className={styles.formTextarea}
                    required
                  ></textarea>
                </div>

                <button type="submit" className={styles.submitBtn}>
                  Send Message
                  <span className={styles.btnIcon}>→</span>
                </button>
              </form>
            </div>
          </div>

          <div className={styles.contactInfoCard}>
            <h3 className={styles.infoTitle}>Alternatively, reach us at:</h3>
            <div className={styles.infoItem}>
              <span className={styles.infoIcon}>✉️</span>
              <p>imagecompressor123@gmail.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
